var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.194 2.05a2.68 2.68 0 0 1 2.678 2.679v15.585a1.64 1.64 0 0 1-2.452 1.421l-4.688-2.677a1.48 1.48 0 0 0-1.465 0l-4.689 2.677a1.64 1.64 0 0 1-2.232-.604 1.64 1.64 0 0 1-.22-.817V4.729A2.68 2.68 0 0 1 6.806 2.05zm-10.39 1.2a1.48 1.48 0 0 0-1.478 1.479v15.584a.44.44 0 0 0 .219.38.44.44 0 0 0 .438 0l4.688-2.677a2.68 2.68 0 0 1 2.657 0l4.688 2.677a.44.44 0 0 0 .437 0 .44.44 0 0 0 .219-.38V4.729a1.48 1.48 0 0 0-1.478-1.479z"
  })));
};
export default SvgBookmark;